export const ACTION_CODE = 'VEHICLE_TYPE_ACTION';
